import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $vznListEl = $('.vzn-list');
let abortController = undefined;

$(function () {
    if ($vznListEl.length > 0) {
        $vznListEl.each(function () {
            vznList($(this));
        });
    }
});

const vznList = (listEl) => {

    const filter = {
        page: 1,
        limit: listEl.data('limit'),
        state: listEl.data('state'),
        categories: listEl.data('categories'),
        category: listEl.data('category'),
        search: '',
        dateStart: '',
        dateEnd: '',
        lang: listEl.data('lang'),
    };

    bindPagination(listEl, filter);
    bindEventFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    abortController = new AbortController();

    const data = await getEvents(filter);
   
    if (data) {
        element.find('.vzn-list__content').html(data.html);
        if (scrollTop === true) {
            smoothscroll(element, 'header');
        }
    }
};

const bindPagination = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        filter.page = $(this).data('page');
        reRenderList(element, filter, true);
    });
};

const bindEventFilter = (element, filter) => {

    element.on(
        'input',
        "input[name='vzn-filter-input-search']",
        debounce(function () {
            
            const $input = $(this);
            filter.page = 1;
            filter.search = $input.val();

            if (filter.search) {
                $input.parent().addClass('has-value');
            } else {
                $input.parent().removeClass('has-value');
            }
            abortController?.abort();
            reRenderList(element, filter);
        })
    );

    element.on(
        'change',
        "select[name='vzn-filter-select-state']",
        debounce(function () {
            const $select = $(this);
            filter.page = 1;
            filter.selectState = $select.val();

            if (filter.search) {
                $select.parent().addClass('has-value');
            } else {
                $select.parent().removeClass('has-value');
            }
            reRenderList(element, filter);
        })
    );

    element.on(
        'change',
        "select[name='vzn-filter-select-category']",
        debounce(function () {
            const $select = $(this);
            filter.page = 1;
            filter.selectCategory = $select.val();

            if (filter.search) {
                $select.parent().addClass('has-value');
            } else {
                $select.parent().removeClass('has-value');
            }
            reRenderList(element, filter);
        })
    );


    element.on('click', "button[name='vzn-filter-input-reset']", function () {
        element.find("input[name='vzn-filter-input-search']").val('').trigger('input');
    });

};

const getEvents = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nitra/v1/vzn/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
            signal: abortController?.signal,
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
